import { ProfileModel } from '../../profile/model/profile.model';
import { ModuleModel } from '../../module.model.interface';

export enum FormType {
  DataEntry,
  Universal,
}

export class FormTypeDetail implements ModuleModel {
  public discriminator = 'FormTypeDetail';
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const FormTypeMap = {
  DataEntry: new FormTypeDetail({ id: 'DataEntry', name: 'Adatszolgáltatás' }),
  Universal: new FormTypeDetail({ id: 'Universal', name: 'Nyilvántartási elem' }),
};

export const FormTypeList: FormTypeDetail[] = [
  FormTypeMap.DataEntry,
  FormTypeMap.Universal,
];

export enum Frequency {
  NotRepeated,
  Daily,
  Weekly,
  Monthly,
  Quarterly,
  HalfYearly,
  Yearly
}

export class FrequencyDetail implements ModuleModel {
  public discriminator = 'FrequencyDetail';
  public id: string;
  public name: string;
  public year: number;
  public month: number;
  public day: number;

  constructor(options?: {
    id: string,
    name: string,
    year: number;
    month: number;
    day: number;
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
      this.year = options.year;
      this.month = options.month;
      this.day = options.day;
    }
  }
}

export const FrequencyMap = {
  NotRepeated: new FrequencyDetail({ id: 'NotRepeated', name: 'Nincs ismétlődés', year: 0, month: 0, day: 0 }),
  Daily: new FrequencyDetail({ id: 'Daily', name: 'Napi', year: 0, month: 0, day: 1 }),
  Weekly: new FrequencyDetail({ id: 'Weekly', name: 'Heti', year: 0, month: 0, day: 7 }),
  Monthly: new FrequencyDetail({ id: 'Monthly', name: 'Havi', year: 0, month: 1, day: 0 }),
  Quarterly: new FrequencyDetail({ id: 'Quarterly', name: 'Negyedéves', year: 0, month: 3, day: 0 }),
  HalfYearly: new FrequencyDetail({ id: 'HalfYearly', name: 'Féléves', year: 0, month: 6, day: 0 }),
  Yearly: new FrequencyDetail({ id: 'Yearly', name: 'Éves', year: 1, month: 0, day: 0 }),
};

export const FrequencyList: FrequencyDetail[] = [
  FrequencyMap.NotRepeated,
  FrequencyMap.Daily,
  FrequencyMap.Weekly,
  FrequencyMap.Monthly,
  FrequencyMap.Quarterly,
  FrequencyMap.HalfYearly,
  FrequencyMap.Yearly,
];

export class FormDescriptor implements ModuleModel {
  public discriminator = 'FormDescriptor';

  public id: string;
  public identifier: string;
  public version: number;
  public title: string;
  public designerId: string;
  public clerkId: string;
  public validFrom: Date;
  public validUntil?: Date;
  public frequency: Frequency;
  public usedAsTemplate: boolean;
  public parentFormId: string;
  public prequisiteFormId: string;
  public prequisiteFormFieldAliasForReference: string;
  public masterFormId: string;
  public directDownloadOnly: boolean;
  public enableUpload: boolean;
  public assignedWorkflowTemplates: string;
  public enableSecondaryValidation: boolean;
  public enableBatchExport: boolean;
  public formType: FormType;
  public capabilities: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public fullTitle: string;
  public validFromFormatted: string;
  public validUntilFormatted: string;
  public designerInfo?: any;
  public designerDetail?: ProfileModel;
  public designerFullName?: string;
  public clerkInfo?: any;
  public clerkDetail?: ProfileModel;
  public clerkFullName?: string;
  public parentFormDetail?: FormDescriptor;
  public parentFormTitle?: string;
  public prequisiteFormDetail?: FormDescriptor;
  public prequisiteFormTitle?: string;
  public masterFormDetail?: FormDescriptor;
  public masterFormTitle?: string;
  public formDetail?: FormDescriptor;

  constructor(options?: {
    id?: string;
    identifier?: string;
    version?: number;
    title?: string;
    designerId?: string;
    clerkId?: string;
    validFrom?: Date;
    validUntil?: Date;
    frequency?: Frequency;
    usedAsTemplate?: boolean;
    parentFormId?: string;
    prequisiteFormId?: string;
    prequisiteFormFieldAliasForReference?: string;
    masterFormId?: string;
    directDownloadOnly?: boolean;
    enableUpload?: boolean;
    assignedWorkflowTemplates?: string;
    enableSecondaryValidation?: boolean;
    enableBatchExport?: boolean;
    formType: FormType;
    capabilities?: string;
    href?: string;
    modified?: Date;
    deleted?: Date;
  }) {

    if (options) {
      if (options.id) { this.id = options.id; }
      if (options.identifier) { this.identifier = options.identifier; }
      if (options.version) { this.version = options.version; }
      if (options.title) { this.title = options.title; }
      if (options.designerId) { this.designerId = options.designerId; }
      if (options.clerkId) { this.clerkId = options.clerkId; }
      if (options.validFrom) { this.validFrom = options.validFrom; }
      if (options.validUntil) { this.validUntil = options.validUntil; }
      if (options.frequency) { this.frequency = options.frequency; }
      if (options.usedAsTemplate) { this.usedAsTemplate = options.usedAsTemplate; }
      if (options.parentFormId) { this.parentFormId = options.parentFormId; }
      if (options.prequisiteFormId) { this.prequisiteFormId = options.prequisiteFormId; }
      if (options.prequisiteFormFieldAliasForReference) { this.prequisiteFormFieldAliasForReference = options.prequisiteFormFieldAliasForReference; }
      if (options.masterFormId) { this.masterFormId = options.masterFormId; }
      if (options.directDownloadOnly) { this.directDownloadOnly = options.directDownloadOnly; } else { this.directDownloadOnly = false; }
      if (options.enableUpload) { this.enableUpload = options.enableUpload; }
      if (options.assignedWorkflowTemplates) { this.assignedWorkflowTemplates = options.assignedWorkflowTemplates; }
      if (options.enableSecondaryValidation) { this.enableSecondaryValidation = options.enableSecondaryValidation; }
      if (options.enableBatchExport) { this.enableBatchExport = options.enableBatchExport; }
      if (options.formType) { this.formType = options.formType; }
      if (options.capabilities) { this.capabilities = options.capabilities; }
      if (options.href) { this.href = options.href; }
      if (options.modified) { this.modified = options.modified; } else { this.modified = null; }
      if (options.deleted) { this.deleted = options.deleted; } else { this.deleted = null; }
    }
  }

  public get frequencyName(): string {
    return FrequencyMap[this.frequency].name;
  }

  public get formTypeName(): string {
    return FormTypeMap[this.formType].name;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/form/model/form.ts